import React from "react";
import { Button, ButtonGroup, Layout } from "@folio/stripes/components";
import { useHistory, useLocation } from "react-router-dom";
import { useActiveRoles, hasAtLeastOneRole } from "../utils/permissionsUtils";
import { RoleEnum } from "../types/RoleEnum";
import { navigation } from "./navigation";
var NavigationComponent = function () {
    var history = useHistory();
    var location = useLocation();
    var activeRoles = useActiveRoles().roles;
    var currentPath = location.pathname;
    var handleRouteClick = function (navItem) {
        var path = navItem.path;
        if (navItem.defaultParams) {
            var params = new URLSearchParams(navItem.defaultParams).toString();
            path += "?".concat(params);
        }
        history.push(path);
    };
    var checkAccess = function (navItem) {
        var isSuperUser = Array.isArray(activeRoles) && activeRoles.includes(RoleEnum.SUPERUSER);
        var hasRequiredRole = navItem.roles
            ? hasAtLeastOneRole(activeRoles, navItem.roles)
            : true;
        // For excludeSuperuser routes: must have actual role AND not be superuser
        if (navItem.excludeSuperuser) {
            var hasActualRole = navItem.roles && Array.isArray(activeRoles)
                ? navItem.roles.some(function (role) { return activeRoles.includes(role); })
                : false;
            return hasActualRole && !isSuperUser;
        }
        return isSuperUser || hasRequiredRole;
    };
    return (React.createElement(Layout, { className: "padding-start-gutter padding-end-gutter" },
        React.createElement("style", null, "\n          .nav-container-outer {\n            container-type: inline-size;\n          }\n          .horizontal-layout {\n            display: block;\n          }\n          .vertical-layout {\n            display: none;\n          }\n          @container (max-width: 460px) {\n            .horizontal-layout {\n              display: none;\n            }\n            .vertical-layout {\n              display: block;\n            }\n          }\n        "),
        React.createElement("div", { className: "nav-container-outer" },
            React.createElement("div", { className: "horizontal-layout" },
                React.createElement(ButtonGroup, { style: { marginBottom: "1rem" }, fullWidth: true }, Object.values(navigation).map(function (navItem) {
                    var isActive = currentPath.startsWith(navItem.path);
                    var hasAccess = checkAccess(navItem);
                    return (hasAccess && (React.createElement(Button, { key: navItem.path, onClick: function () { return handleRouteClick(navItem); }, style: {
                            backgroundColor: isActive ? "#1960a4" : "",
                            color: isActive ? "#fff" : "",
                            fontWeight: isActive ? "bold" : "",
                        } }, navItem.label)));
                }))),
            React.createElement("div", { className: "vertical-layout" },
                React.createElement("div", { style: {
                        backgroundColor: "#f5f5f5",
                        padding: "1rem",
                        borderRadius: "4px",
                    } },
                    React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "1rem" } }, Object.values(navigation).map(function (navItem) {
                        var isActive = currentPath === navItem.path;
                        var hasAccess = checkAccess(navItem);
                        return (hasAccess && (React.createElement(Button, { key: navItem.path, onClick: function () { return handleRouteClick(navItem); }, buttonStyle: isActive ? "primary" : "default", fullWidth: true, marginBottom0: true, style: { justifyContent: "flex-start" } }, navItem.label)));
                    })))))));
};
export default NavigationComponent;
